<template>
  <div class="container px-5 py-24 mx-auto">
    <div
      class="lg:w-2/3 flex flex-col sm:flex-row sm:items-center items-start mx-auto"
    >
      <h1
        class="flex-grow sm:pr-16 text-5xl font-medium title-font text-gray-900"
      >
        Like what you see?
      </h1>
      <a
        href="mailto:skeith696@gmail.com"
        class="flex-shrink-0 text-white  bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg mt-10 sm:mt-0"
      >
        Contact Me
      </a>
    </div>
  </div>
</template>

<script>
// import GenQrCode from "@/components/GenQrCode";

export default {
  name: "ContactMe",
  //   components: { GenQrCode },
  data: () => ({
    //
  })
};
</script>
